var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "own-the-look" }, [
    _c(
      "button",
      {
        staticClass: "own-the-look__btn",
        on: {
          click: function ($event) {
            _vm.open = true
          },
        },
      },
      [_vm._v("Own the look")]
    ),
    _vm._v(" "),
    _vm.open
      ? _c(
          "div",
          {
            staticClass: "side-panel",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                _vm.open = false
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "side-panel__content own-the-look__panel" },
              [
                _c(
                  "button",
                  {
                    staticClass: "side-panel__close",
                    on: {
                      click: function ($event) {
                        _vm.open = false
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.$cdn("/img/ui/icon-close.svg"),
                        alt: "Close",
                        width: "14",
                        height: "14",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "own-the-look__store" }, [
                  _vm._v(_vm._s(_vm.storeName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "own-the-look__image" }, [
                  _vm.image
                    ? _c("img", {
                        attrs: { src: _vm.image, alt: _vm.product.name },
                        on: {
                          error: function ($event) {
                            _vm.image = null
                          },
                        },
                      })
                    : _c("img", {
                        attrs: {
                          src: _vm.$cdn(_vm.$root.brand.logo_symbol),
                          alt: _vm.product.name,
                          width: "64",
                          height: "64",
                        },
                      }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "own-the-look__category" }, [
                  _vm._v(_vm._s(_vm.product.category)),
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "own-the-look__name" }, [
                  _vm._v(_vm._s(_vm.product.name)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "own-the-look__rating" }, [
                  _vm._v("★ " + _vm._s(_vm.product.rating) + " "),
                  _c("span", [
                    _vm._v("/ " + _vm._s(_vm.product.reviews) + " reviews"),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "own-the-look__price" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.product.price) +
                      "\n                "
                  ),
                  _c("s", [_vm._v(_vm._s(_vm.product.wasPrice))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.product.discount))]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "own-the-look__label" }, [
                  _vm._v("Color: " + _vm._s(_vm.product.color)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "own-the-look__swatches" },
                  _vm._l(_vm.product.swatches, function (swatch) {
                    return _c("button", {
                      key: swatch,
                      class: { selected: swatch === _vm.product.swatch },
                      style: { backgroundColor: swatch },
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _c("p", { staticClass: "own-the-look__label" }, [
                  _vm._v("Size"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "own-the-look__sizes" },
                  _vm._l(_vm.product.sizes, function (size) {
                    return _c(
                      "button",
                      {
                        key: size,
                        class: { selected: size === _vm.selectedSize },
                        on: {
                          click: function ($event) {
                            _vm.selectedSize = size
                          },
                        },
                      },
                      [_vm._v(_vm._s(size))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "own-the-look__buy" }, [
                  _c("div", { staticClass: "own-the-look__quantity" }, [
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.quantity = Math.max(1, _vm.quantity - 1)
                          },
                        },
                      },
                      [_vm._v("−")]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.quantity))]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.quantity += 1
                          },
                        },
                      },
                      [_vm._v("+")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "own-the-look__cart",
                      attrs: {
                        href: _vm.$root.brand.store_link,
                        target: "_blank",
                        rel: "noopener",
                      },
                    },
                    [_vm._v("Add to cart")]
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "own-the-look__returns" }, [
      _vm._v("Return & Exchange"),
      _c("br"),
      _c("span", [_vm._v("Free 30 Days Delivery & Returns")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }